import { FC } from 'react';

import IconTooltip from 'modules/_shared/components/Icon/IconTooltip';
import { useGetUsufructuariesTooltipText } from 'modules/partners/hooks/useGetUsufructuariesTooltipText';

import { formatNumberDecimals } from 'utils/formats';
import { ContributionData } from '../types/ContributionData';

type ContributionTableRowProps = {
  index: number;
  contribution: ContributionData;
};
const ContributionTableRow: FC<ContributionTableRowProps> = ({
  index,
  contribution,
}) => {
  const { partnerName, ndPercent, toPerceive, usufructData } = contribution;

  const {
    data: { tooltipText },
  } = useGetUsufructuariesTooltipText({
    usufructData,
  });

  return (
    <>
      <td className="tb-tnx-info" key={`name-${index}`}>
        <div className="tb-tnx-info w-150px d-flex align-items-center">
          <span className="title">{partnerName}</span>
          {tooltipText && (
            <IconTooltip id={`usufruct-info-${index}`} tooltip={tooltipText} />
          )}
        </div>
      </td>

      <td className="tb-tnx-item" key={`ndPercent-${index}`}>
        <span className="tb-tnx-total text-right w-100">
          {formatNumberDecimals(ndPercent)}%
        </span>
      </td>

      <td className="tb-tnx-item">
        <span
          className="tb-tnx-total text-right w-100"
          key={`toPerceive-${index}`}
        >
          {formatNumberDecimals(toPerceive)}€
        </span>
      </td>
    </>
  );
};

export default ContributionTableRow;
